import { Action } from "redux";

import { GET_ORDERS, GET_CERTIFIED_ORDERS, IS_LOADING } from "./types";

interface OrderAction extends Action {
  payload: any;
}

const initialState = {
  orders: [],
  certifiedOrders: [],
  loading: false,
};

export default (state = initialState, action: OrderAction) => {
  switch (action.type) {
    case GET_ORDERS:
      return {
        ...state,
        orders: action.payload,
      };
    case GET_CERTIFIED_ORDERS:
      return {
        ...state,
        certifiedOrders: action.payload,
      };
    case IS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};
